import { Box } from "@mui/system";
import React, { Component } from "react";
import MUISwitch from "../components/ui-components/toggleSwitch";
import CircularProgress from '@mui/material/CircularProgress';
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { ChevronRightRounded } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import NightlifeIcon from "@mui/icons-material/Nightlife";
import LocalCafeIcon from "@mui/icons-material/LocalCafe";
import Stack from "@mui/material/Stack";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Container, Divider } from "@mui/material";
import TransactionList from "../components/ui-components/transactionList";

import { Button } from "@mui/material";
import { Link } from "react-router-dom"
import Progress from "../components/ui-components/graphs/Progress";
import PieGraph from "../components/ui-components/graphs/PieGraph";

import TransactionScreen from "../components/ui-components/transactionScreen";
import { GradientButton } from "../components/ui-components/GradientButton";

import { getURLBase, updateParentHeight } from '../utils/helperFns';
import axios from "axios";
import wyzrTheme from "../styles/customTheme";

export class UpcomingSpends extends Component {
	constructor(props) {
		super(props);
		this.url = getURLBase(true) + "/upcomingspend";
		this.state = {
			isReady: false,
			amountPrefix: "£"
		}
	}
	componentDidMount() {
		axios.post(this.url, { gid: this.props.gid }).then(
			(response) => {
				this.setState(response.data.body)

				if (this.state.currentViewisMoney) {
					this.processData(this.state.data.moneyTab.pieData);
				} else {
					this.processData(this.state.data.footprintTab.pieData);
				}

				this.setState({
					isReady: true,
				})
			}
		)
	}
	handleChange = () => {
		this.setState({
			currentViewisMoney: !this.state.currentViewisMoney,
		});
		if (!this.state.currentViewisMoney) {
			this.processData(this.state.data.moneyTab.pieData);
			this.setState({ amountPrefix: "£" })
		} else {
			this.processData(this.state.data.footprintTab.pieData);
			this.setState({ amountPrefix: "kg" })
		}
	};

	toggleTransactionScreen = () => {
		var transactionShown = this.state.showAllTransaction;
		transactionShown = !transactionShown;
		this.setState({ showAllTransaction: transactionShown },
			() => {
				updateParentHeight("parent_UpcomingSpends", "child_TransactionScreen", this.state.showAllTransaction);
			});
	}

	processData = (response) => {
		let moreData = response;
		response = response.processData;
		let textdata = response.text;
		let piedata = [];

		let d = new Map(Object.entries(response.debit));
		let c = new Map(Object.entries(response.credit));
		let total = 0;

		for (const [k, v] of c.entries()) {
			piedata.push({ name: k, value: v });
			total += v;
		}

		for (const [k, v] of d.entries()) {
			piedata.push({ name: k, value: v });
			total += v;
		}
		this.setState({
			piedata: piedata,
			textdata: textdata,
			total: Math.round(total * 100) / 100,
			moreData: moreData,
		});
	};

	render() {
		const WidgetData = () => (
			<Card className={"widgetCard cardShadow "} id="parent_UpcomingSpends">
				{this.state.isReady ?
					<>
						<Typography variant="h4" sx={{ fontWeight: 700 }} align="center" mx={"auto"} width="65%">
							{this.state.currentViewisMoney
								? this.state.data.moneyTab.tabHeading
								: this.state.data.footprintTab.tabHeading}
						</Typography>
						<Typography
							variant="subtitle1"
							color="text.secondary"
							fontWeight="600"
							align="center"
							gutterBottom
						>
							{this.state.currentViewisMoney
								? this.state.data.moneyTab.subHeading
								: this.state.data.footprintTab.subHeading}
						</Typography>
						<Button sx={{
							margin: "0 auto",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							marginY: "0.5rem",
							marginTop: "-0.5rem",
							// fontSize: "0.7rem",
							padding: "2px"
						}}
							onClick={() => this.props.setEmbedUrl(this.state.tutorial_iframe)}
						>
							See how this works <img src="/tutorial-icon.png" style={{ width: "35px", padding: "5px" }} />
						</Button>
						<Divider light />
						<CardContent textAlign="center" className={`${this.state.isReady ? (this.state.currentViewisMoney ? ((this.state.data.moneyTab.pieData.total === null || this.state.data.moneyTab.pieData.total === 0) ? "widgetCard cardShadow blur" : "widgetCard cardShadow") : ((this.state.data.footprintTab.pieData.total === null || this.state.data.footprintTab.pieData.total === 0) ? "widgetCard cardShadow blur" : "widgetCard cardShadow")) : ""}`}>
							<PieGraph
								total={this.state.total}
								piedata={this.state.piedata}
								moreData={this.state.moreData}
								colors={["#eee", "#e96e66"]}
							/>
							{this.state.currentViewisMoney ? (
								<Progress
									width="100%"
									prefix={" "}
									startText={this.state.data.moneyTab.progressData.startText}
									endText={this.state.data.moneyTab.progressData.endText}
									startNumber={this.state.data.moneyTab.progressData.startNumber}
									endNumber={this.state.data.moneyTab.progressData.endNumber}
									color={this.state.data.moneyTab.progressData.color === "error" && this.state.data.moneyTab.progressData.subcolor === "light" ? wyzrTheme.palette.error.light
										: this.state.data.moneyTab.progressData.color === "primary" && this.state.data.moneyTab.progressData.subcolor === "light" ? wyzrTheme.palette.primary.light : ""}
								/>
							) : (
								<Progress
									width="100%"
									prefix={" "}
									startText={this.state.data.footprintTab.progressData.startText}
									endText={this.state.data.footprintTab.progressData.endText}
									startNumber={
										this.state.data.footprintTab.progressData.startNumber
									}
									endNumber={this.state.data.footprintTab.progressData.endNumber}
									color={this.state.data.moneyTab.progressData.color === "error" && this.state.data.moneyTab.progressData.subcolor === "light" ? wyzrTheme.palette.error.light
										: this.state.data.moneyTab.progressData.color === "primary" && this.state.data.moneyTab.progressData.subcolor === "light" ? wyzrTheme.palette.primary.light : ""}
								/>
							)}

							<Grid mt={2}>
								<Paper variant="outlined" sx={{ borderColor: "grey.200" }}>
									<Grid padding={2}>
										<TransactionList
											heading={
												this.state.currentViewisMoney
													? this.state.data.moneyTab.transactions.committed.heading
													: this.state.data.footprintTab.transactions.committed
														.heading
											}
											transactionStatus={
												this.state.currentViewisMoney
													? this.state.data.moneyTab.transactions.committed
														.transactionStatus
													: this.state.data.footprintTab.transactions.committed
														.transactionStatus
											}
											transactionDetails={
												this.state.currentViewisMoney
													? this.state.data.moneyTab.transactions.committed
														.shorttransaction
													: this.state.data.footprintTab.transactions.committed
														.shorttransaction
											}
											prefix={this.state.amountPrefix}
										/>
										{/* `${(this.state.total === null || this.state.total === 0) ? null : this.toggleTransactionScreen}` */}
										<Box textAlign="center" mt={2}>
											<Button
												variant="outlined"
												fontWeight="800"
												textTransformtype="capitalize"
												onClick={this.state.currentViewisMoney ? (this.state.data.moneyTab.pieData.total === null || this.state.data.moneyTab.pieData.total === 0) ? null : this.toggleTransactionScreen : (this.state.data.footprintTab.pieData.total === null || this.state.data.footprintTab.pieData.total === 0) ? null : this.toggleTransactionScreen}
												endIcon={<ChevronRightRounded colorprimary />}
											>
												See More
											</Button>
										</Box>

									</Grid>
								</Paper>
							</Grid>

							<Grid mt={2}>
								<Paper variant="outlined" sx={{ borderColor: "grey.200" }}>
									<Grid padding={2}>
										{/* <TransactionList
										showNoDataMessage={true}
											heading={
												this.state.currentViewisMoney
													? "Miscellaneous spends"
													: this.state.data.footprintTab.transactions.nonCommitted
														.heading
											}
											transactionStatus={
												this.state.currentViewisMoney
													? this.state.data.moneyTab.transactions.nonCommitted
														.transactionStatus
													: this.state.data.footprintTab.transactions.nonCommitted
														.transactionStatus
											}
											transactionDetails={
												this.state.currentViewisMoney
													? this.state.data.moneyTab.transactions.nonCommitted
														.shorttransaction
													: this.state.data.footprintTab.transactions.nonCommitted
														.shorttransaction
											}
											prefix={this.state.amountPrefix}
										/> */}
										{
											this.state.currentViewisMoney ?

												<Grid container mb={1} justifyContent="space-between">
													<Grid item>
														<Typography gutterBottom variant="h6">
															Miscellaneous spends
														</Typography>
													</Grid>
													<Grid item justifyContent={"end"}>

														<Stack direction="row" spacing={1}>
															<ShoppingBagIcon fontSize="medium" />
															<FastfoodIcon fontSize="medium" />
															<NightlifeIcon fontSize="medium" />
															<LocalCafeIcon fontSize="medium" />
															<MoreHoriz fontSize="medium" />
														</Stack>
													</Grid>
												<Container sx={{ display: "flex", alignItems: "center", justifyContent: "space-around", marginY: "10px", marginTop: '22px', marginLeft: "35px", marginRight: "35px", marginBottom: "-10px" }}>
														<div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
															<Typography component="p" variant="body1" color="primary" gutterBottom fontWeight={900} marginBottom="-0.2em">
																£ {this.state.data.moneyTab.transactions.nonCommitted
																	.shorttransaction.miscbudget}
															</Typography>
															<Typography component="p" variant="body1" sx={{ color: "darkgrey !important" }}>
																Budget
															</Typography>
														</div>
														<div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
															<Typography component="p" variant="body1" color="primary" gutterBottom fontWeight={900} marginBottom="-0.2em">
																£ {this.state.data.moneyTab.transactions.nonCommitted
																	.shorttransaction.miscspent}
															</Typography>
															<Typography component="p" variant="body1" sx={{ color: "darkgrey !important" }}>
																Spent
															</Typography>
														</div>
														<div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
															<Typography component="p" variant="body1" color="primary" gutterBottom fontWeight={900} marginBottom="-0.2em">
																£ {this.state.data.moneyTab.transactions.nonCommitted
																	.shorttransaction.miscremaining}
															</Typography>
															<Typography component="p" variant="body1" sx={{ color: "darkgrey !important" }}>
																Remaining
															</Typography>
														</div>
													</Container>
												</Grid>
												:
												<>
													<Paper variant="outlined" sx={{ borderColor: "grey.200" }}>
														<Grid padding={2}>
															<TransactionList
																showNoDataMessage={true}
																heading={this.state.data.footprintTab.transactions.nonCommitted.heading}
																transactionStatus={this.state.data.footprintTab.transactions.nonCommitted.transactionStatus}
																transactionDetails={this.state.data.footprintTab.transactions.nonCommitted.shorttransaction}
																prefix={this.state.amountPrefix}
															/>
														</Grid>
													</Paper>
												</>
										}
									</Grid>
								</Paper>
							</Grid>
							<Box textAlign="center" mt={2}>
								<Button
									component={Link}
									variant="outlined"
									fontWeight="800"
									to="/spending"
									endIcon={<ChevronRightRounded colorPrimary />}
								>
									See other weeks
								</Button>
							</Box>
						</CardContent>

						{
							this.state.showAllTransaction ?
								<TransactionScreen
									toggleHandler={this.toggleTransactionScreen}
									transactions={
										this.state.currentViewisMoney
											? this.state.data.moneyTab.transactions
											: this.state.data.footprintTab.transactions
									}
									prefix={this.state.amountPrefix}
								/> : null
						}

					</>
					: <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "20vh" }}><CircularProgress color="success" /></Box>
				}

			</Card>


		);


		return (
			<Box sx={{ position: "relative" }}>
				<Box sx={{ position: "absolute", top: 0, right: 0, zIndex: 1 }}>
					<MUISwitch handleClick={this.handleChange} />
				</Box>

				<WidgetData />


			</Box>
		);
	}
}

export default UpcomingSpends;
